import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./styles.scss";
import { SNACKBAR_TYPE } from "../../constants/notificationType";
import Success from "../Icon/Success";
import Alert from "../Icon/Alert";
import Info from "../Icon/Info";
import Warning from "../Icon/Warning";

const SNACKBAR_ICON = {
  [SNACKBAR_TYPE.SUCCESS]: <Success className="snackbar-icon" />,
  [SNACKBAR_TYPE.ALERT]: <Alert classNames="snackbar-icon" />,
  [SNACKBAR_TYPE.INFO]: <Info className="snackbar-icon" />,
  [SNACKBAR_TYPE.WARNING]: <Warning className="snackbar-icon" />,
};

const Snackbar = ({ type, message }) => (
  <div className={classNames("snackbar", `snackbar-${type}`)}>
    {SNACKBAR_ICON[type]}
    <div className="snackbar-message">{message}</div>
  </div>
);

Snackbar.defaultProps = {
  type: SNACKBAR_TYPE.INFO,
};

Snackbar.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(SNACKBAR_TYPE)),
};

export default Snackbar;
